// Pure date/streak helpers shared by the trainings DB layer and the training session UI.
import { format, parseISO, differenceInDays, addDays } from 'date-fns';
import { toZonedTime, fromZonedTime } from 'date-fns-tz';
import { softResetStreak } from './shurikens.js';

export const DEFAULT_SCHOOL_TIMEZONE = 'Asia/Jerusalem';

// Calendar date ('yyyy-MM-dd') of `date` in the school's timezone
export function schoolDate(date, timezone = DEFAULT_SCHOOL_TIMEZONE) {
  return format(toZonedTime(date, timezone), 'yyyy-MM-dd');
}

// UTC ISO bounds [start, end) of the school-timezone day containing `date`.
// startedAt is stored as a UTC ISO string, so queries must use real UTC bounds.
export function schoolDayBoundsUtc(date, timezone = DEFAULT_SCHOOL_TIMEZONE) {
  const day = schoolDate(date, timezone);
  const nextDay = format(addDays(parseISO(day), 1), 'yyyy-MM-dd');
  return {
    start: fromZonedTime(`${day}T00:00:00`, timezone).toISOString(),
    end: fromZonedTime(`${nextDay}T00:00:00`, timezone).toISOString(),
  };
}

// Streak after training on `today` ('yyyy-MM-dd'), given the user's current stats
export function computeStreakUpdate(stats, today) {
  const lastDate = stats.lastTrainingDate;
  const currentStreak = stats.currentStreak || 0;

  if (!lastDate) {
    return { newStreak: 1, streakIncremented: true, streakBroken: false };
  }

  const daysDiff = differenceInDays(parseISO(today), parseISO(lastDate));
  if (daysDiff <= 0) {
    // Same day (or an older session synced late) - no change
    return { newStreak: currentStreak, streakIncremented: false, streakBroken: false };
  }
  if (daysDiff === 1) {
    return { newStreak: currentStreak + 1, streakIncremented: true, streakBroken: false };
  }
  // Streak broken - soft reset to nearest 25-day milestone instead of hard reset to 1
  return { newStreak: softResetStreak(currentStreak), streakIncremented: false, streakBroken: true };
}
